export enum ScreenWidth {
  desktop = 1440,
  laptop = 1024,
  tablet = 768,
  mobile = 576,
}

export const emailApp = 'agent@eclipse.club';
export const itemsOnPageQuantity = 10;
